import { render, staticRenderFns } from "./IBeaconTable.vue?vue&type=template&id=400b4600&scoped=true"
import script from "./IBeaconTable.vue?vue&type=script&lang=js"
export * from "./IBeaconTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b4600",
  null
  
)

export default component.exports